import axios from "axios";
import JSCookie from "js-cookie";
import { reject } from "lodash";

const FetchToken = () => {
  if (!JSCookie.get("inizionavigator")) return null;
  const token = JSON.parse(JSCookie.get("inizionavigator")).token;
  return token;
};
const Acctoken = FetchToken();

const config = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  withCredentials: true
});

// ─── Shared refresh machinery ───────────────────────────────────────────────
let isRefreshing = false;
let failedQueue = [];

function processQueue(error = null) {
  failedQueue.forEach(({ resolve, reject }) => {
    error ? reject(error) : resolve();
  });
  failedQueue = [];
}

function refreshToken() {
  // use your main `config` instance so cookies get updated properly
  return config.post(
    "/azure/refresh-token",
    {},
    { withCredentials: true }
  );
}
// ────────────────────────────────────────────────────────────────────────────

config.interceptors.request.use(
  req => {
    // (optional) If you want to add Bearer header:
    // const token = FetchToken();
    // if (token) req.headers.Authorization = `Bearer ${token}`;
    return req;
  },
  err => Promise.reject(err)
);

config.interceptors.response.use(
  response => response,
  error => {

    console.log(error?.config?.url, error.status, "error");
    if (error?.config?.url === "/azure/refresh-token") {
      window.location.replace("/login");
    }
    if (error?.config?.url === '/api/user/me' && error.status !== 401) {
      window.location.replace("/login");
    }

    const { response, config: originalReq } = error;
    if (!response || response.status !== 401) {
      // not a 401 → reject
      return Promise.reject(error);
    }

    // avoid infinite loops
    if (originalReq._retry) {
      return Promise.reject(error);
    }
    originalReq._retry = true;

    if (isRefreshing) {
      // already refreshing → queue this request
      return new Promise((resolve, reject) => {
        failedQueue.push({ resolve, reject });
      })
        .then(() => config(originalReq))
        .catch(err => Promise.reject(err));
    }

    // start refresh
    isRefreshing = true;
    return new Promise((resolve, reject) => {
      refreshToken()
        .then(() => {
          processQueue(null);
          resolve(config(originalReq));
        })
        .catch(err => {
          processQueue(err);
          // refresh failed → force logout
          window.location.replace("/login");
          reject(err);
        })
        .finally(() => {
          isRefreshing = false;
        });
    });
  }
);

// ─── configV2 ──────────────────────────────────────────────────────────────
const configV2 = axios.create({
  baseURL: process.env.REACT_APP_IPT_BASE_URL,
  withCredentials: true
});

configV2.interceptors.request.use(
  req => req,
  err => Promise.reject(err)
);

configV2.interceptors.response.use(
  response => response,
  error => {
    const { response, config: originalReq } = error;
    if (!response || response.status !== 401) {
      return Promise.reject(error);
    }
    if (originalReq._retry) {
      return Promise.reject(error);
    }
    originalReq._retry = true;

    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        failedQueue.push({ resolve, reject });
      })
        .then(() => configV2(originalReq))
        .catch(err => Promise.reject(err));
    }

    isRefreshing = true;
    return new Promise((resolve, reject) => {
      // Always use the main `config` to refresh
      refreshToken()
        .then(() => {
          processQueue(null);
          resolve(configV2(originalReq));
        })
        .catch(err => {
          processQueue(err);
          window.location.replace("/login");
          reject(err);
        })
        .finally(() => {
          isRefreshing = false;
        });
    });
  }
);

export { configV2 };
export default config;
